"use client";

import clsx from "clsx";

export const ContainerXL = ({ children, className, ...props }) => (
  <div
    className={clsx("w-full", "max-w-7xl", "mx-auto", "px-8", className)}
    {...props}
  >
    {children}
  </div>
);

export default ContainerXL;
